import "core-js/modules/es.number.constructor.js";
// import { h } from 'vue'
export default {
  components: {
    'my-render': {
      functional: true,
      props: {
        cellValue: {},
        row: {
          type: Object
        },
        render: {
          type: Function
        },
        rowIndex: {
          type: Number
        }
      },
      render: function render(h, ctx) {
        return ctx.props.render(h, ctx.props.row, ctx.props.cellValue, ctx.props.rowIndex);
      }
    }
  },
  directives: {
    ht: {
      updated: function updated(el, binding) {
        var headHeight = binding.value.headHeight;
        var fixHeaght = binding.value.fixHeaght;
        if (!fixHeaght) return;
        if (headHeight === -1) {
          el.style.maxHeight = 'auto';
          return;
        }
        if (headHeight === 0) {
          el.style.maxHeight = 'calc(100vh - 190px - ' + 100 + 'px)';
          el.style.overflow = 'auto';
          return;
        }
        el.style.maxHeight = 'calc(100vh - 190px - ' + headHeight + 'px)';
        el.style.overflow = 'auto';
      }
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    headHeight: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        // 默认配置
        fixHeaght: true,
        // 固定高度
        // table 属性
        size: 'mini',
        // 表格大小
        stripe: true,
        // 是否为斑马纹 table
        border: false,
        // 是否带有纵向边框
        highlightCurrentRow: false,
        // 是否要高亮当前行
        multipleRowSelect: false,
        // 是否支持表格行多选
        index: false,
        // 是否支持索引序列
        headStyle: {},
        // 表头颜色
        rowStyle: {},
        // 行的 style 的回调方法
        // commonStyle: { minHeight: '60vh' }, // table的样式
        // 分页
        pagination: true,
        page_size: 10,
        page_index: 0,
        total: 0,
        align: 'center',
        emptyText: '暂无数据',
        // 无数据提示
        /* 分页事件 */

        // 页码改变
        currentChange: function currentChange(page) {
          console.log(page);
        },
        // pagesize改变
        sizeChange: function sizeChange(size) {
          console.log(size);
        },
        /*  表格事件  */

        // 单击表格行事件
        rowClick: function rowClick(row, column, event) {},
        //  当选择项发生变化时会触发该事件
        selectionChange: function selectionChange(selection) {
          console.log(selection);
        },
        // 固定表头
        height: this.tableData.length ? '1000px' : '100%',
        // 是否需要控制勾选框的状态
        hasSelectable: false
      },
      renderKey: Math.random(),
      renderKey1: Math.random()
    };
  },
  computed: {
    config: function config() {
      return Object.assign({}, this.defaultConfig, this.options); // 拿外部options覆盖默认配置
    },
    getAlign: function getAlign() {
      var _this = this;
      return function (column) {
        return column.align === 'left' ? 'left' : _this.config.align;
      };
    },
    indexMethod: function indexMethod(index) {
      return 50 * this.config.page_index + 1;
    }
  },
  watch: {
    'config.page_index': {
      deep: true,
      handler: function handler(newVal, val) {
        // console.log('config.page_index=>newVal:', newVal)
        // console.log('config.page_index=>val:', val)
      }
    },
    'page_index': {
      deep: true,
      handler: function handler(newVal, val) {
        // console.log('page_index=>newVal:', newVal)
        // console.log('page_index=>val:', val)
      }
    }
  },
  created: function created() {
    // console.log('commonTable=>columns:', this.columns)
  },
  mounted: function mounted() {
    this.renderKey = Math.random();
    this.renderKey1 = Math.random();
  },
  methods: {
    selectable: function selectable(row) {
      if (!this.config.hasSelectable) return true;
      return row.isSelectable;
    }
  }
};